import script from "./CRM01_013INS.vue?vue&type=script&setup=true&lang=js"
export * from "./CRM01_013INS.vue?vue&type=script&setup=true&lang=js"

import "./CRM01_013INS.vue?vue&type=style&index=0&id=a0dd9d88&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a0dd9d88"]])

export default __exports__